import { render, staticRenderFns } from "./HistoricoCargaPatrimonialList.vue?vue&type=template&id=49b1a83e"
import script from "./HistoricoCargaPatrimonialList.vue?vue&type=script&lang=js"
export * from "./HistoricoCargaPatrimonialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports